import { supportedChains, TChainName } from '../types';

function ensureNotEmpty(value: string, name: string) {
    if (!value) {
        throw new Error(`The provided ${name} is empty`);
    }
}

export async function readStorageAt(
    contractAddress: string,
    slotHash: string,
    rpc: string
): Promise<string> {

    let implAddress: string = '';

    const data = {
        jsonrpc: '2.0',
        method: 'eth_getStorageAt',
        params: [contractAddress, slotHash, 'latest'],
        id: 1
    };

    try {

        ensureNotEmpty(contractAddress, 'contractAddress');
        ensureNotEmpty(slotHash, 'slotHash');
        ensureNotEmpty(rpc, 'rpc');

        const response = await fetch(rpc, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.error) {
            throw new Error(`Error from Ethereum node: ${result.error.message}`);
        }

        implAddress = result.result

    } catch (error) {
        console.error('Error reading storage slot:', error);
    }

    return implAddress;

}

export async function getImplementation(proxy: string, chainName: TChainName): Promise<string> {

    const impl_slot: string = '0x360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc';
    const rpc: string = supportedChains[chainName].rpc;

    const implAddress: string = await readStorageAt(proxy, impl_slot, rpc);

    if (implAddress && implAddress.substring(0, 26) === '0x000000000000000000000000') {
        return implAddress.replace('000000000000000000000000', '');
    }

    return implAddress;

}

getImplementation('0x59cD1C87501baa753d0B5B5Ab5D8416A45cD71DB', 'ethereum')